import { IJoinTextObject } from "../../../../../domain/editableFormat/objects";
import { IJoinTextObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { CalculatableObjectTranslator } from "./base";
import {
  TextJoinBehaviorTranslator,
  RelationReplacer,
  ItemSelectTriggerBehaviorTranslator,
} from "./properties";

export class JoinTextObjectTranslator extends AbstractObjectTranslator<IJoinTextObject, IJoinTextObjectBean> {
  constructor() {
    super(new CalculatableObjectTranslator());
  }

  protected shouldRecordName(source: IJoinTextObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IJoinTextObject, bean: IJoinTextObjectBean, formatId: number): void {
    source.textJoinBehavior = this.textJoinBehavior.from(bean);
    source.itemSelectTriggerBehavior = this.itemSelectTriggerBehavior.from(bean);
  }

  overwriteBean(source: IJoinTextObjectBean, object: IJoinTextObject): void {
    const behavior = this.textJoinBehavior.to(object.textJoinBehavior);
    source["@join-word"] = behavior.joinWord;
    source.jointextitem = behavior.joinTextItem;
    this.relationReplacer.replaceBeans(
      source,
      "user-define",
      this.itemSelectTriggerBehavior.to(object.itemSelectTriggerBehavior));
}

  private readonly textJoinBehavior = new TextJoinBehaviorTranslator();
  private readonly itemSelectTriggerBehavior = new ItemSelectTriggerBehaviorTranslator();
  private readonly relationReplacer = new RelationReplacer();
}
